import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { atom, useSetRecoilState } from "recoil";
import { GetSubscriptionSetData } from "../../../../../ApiTS/ServiceDatasTS";
import { useApi } from "../../../../../hooks/useApi";
import LineBtn from "../../../../Button/LineBtn";
import Loader from "../../../../DefaultStyles/Loader";
import AlertModal from "../../../../Modal/AlertModal";
import AlimTalkModal from "../../../AlimTalk/AlimTalkModal";

interface GetTempAccountBtnProps {
  buttonDisabled: boolean;
  subsId: number;
  clickEvent: () => void;
  historyInfo: {
    user: string;
    subsData: string;
    partyId: string;
  };
  refetch: () => void;
}

export const tempAccountSelectState = atom({
  key: "tempAccountSelectState",
  default: true,
});

export default function GetTempAccountBtn({
  buttonDisabled,
  subsId,
  clickEvent,
  historyInfo,
  refetch,
}: GetTempAccountBtnProps) {
  const subsData = GetSubscriptionSetData(subsId ?? 0);

  const [checkList, setCheckList] = useState(false);
  const [cannotGiveAccountAlert, setCannotGiveAccountAlert] = useState(false);
  const [alimtalkModal, setAlimtalkModal] = useState(false);
  const [searchTargetBtnClick, setSearchTargetBtnClick] = useState(false);
  const [targetUid, setTargetUid] = useState("");

  const { response: resUser, loading: loadingUser } = useApi({
    method: "get",
    url: searchTargetBtnClick
      ? `user/info/${historyInfo?.user ?? 0}`
      : undefined,
  });

  // check temp-account list
  const { response, loading, error } = useApi({
    method: "get",
    url: checkList ? `temp-account?servid=${subsData?.SVC_ID ?? 0}` : undefined,
  });

  useEffect(() => {
    if (resUser && resUser?.status === 200) {
      setSearchTargetBtnClick(false);
      setTargetUid(
        `${resUser?.data?.uid}_${resUser?.data?.name}_${resUser?.data?.nickname}`
      );
      setTimeout(() => {
        setAlimtalkModal(true);
      }, 500);
    }
  }, [resUser, setTargetUid]);

  useEffect(() => {
    if (response?.status === 200) {
      setCheckList(false);
      console.log(response);

      if (response?.data?.length > 0) {
        let nowAllotCount = 0; // 현재 발급 된 임시 계정 수

        response?.data?.forEach((el: any) => {
          const allotCount = el?.partyid?.length;
          nowAllotCount += allotCount;
        });

        console.log(
          nowAllotCount,
          (subsData?.POL_SHARMX ?? 0) * response?.data?.length
        );

        // 발급 가능
        if (
          nowAllotCount <
          (subsData?.POL_SHARMX ?? 0) * response?.data?.length
        ) {
          setSearchTargetBtnClick(true); // 유저 정보 체크하기
        } else {
          setCannotGiveAccountAlert(true);
        }
      } else {
        setCannotGiveAccountAlert(true);
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      setCheckList(false);

      toast.error(
        error?.data ?? "임시 계정 리스트를 조회하는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <LineBtn
        btnText="발급"
        disabled={buttonDisabled}
        btnClickEvent={() => {
          clickEvent();
          setCheckList(true);
        }}
      />

      {(loading || loadingUser) && <Loader />}

      {/* 발급 가능한 계정 없음 */}
      {cannotGiveAccountAlert && (
        <AlertModal
          title={`발급 가능한 계정이 없습니다.
        임시 계정을 확인해 주세요.`}
          confirmEvent={() => setCannotGiveAccountAlert(false)}
          customCancelBtn={<></>}
        />
      )}

      {/* 알림톡 모달 */}
      {alimtalkModal && (
        <AlimTalkModal
          type="input"
          closeEvent={() => setAlimtalkModal(false)}
          viewData={{
            ...historyInfo,
            user: targetUid,
            template: `2012_임시 계정 안내`,
          }}
          confirmEvent={() => refetch()}
        />
      )}
    </>
  );
}
